import React, { useState, useContext } from 'react';
import { AuthContext } from '../../common/contexts/AuthContext';
// import PropTypes from 'prop-types';
import { useIdleTimer } from 'react-idle-timer';
import TimeoutWarning from './TimeoutWarning';

function TimeoutCheck() {
  const [isTimeoutWarningOpen, setTimeoutWarningOpen] = useState(false);
  const { sessionHelpers } = useContext(AuthContext);

  const timeout =
    1000 * 60 * process.env.REACT_APP_IDLE_TIMEOUT_WARNING_MINUTES;
  const handleOnIdle = () => {
    setTimeoutWarningOpen(true);
  };

  useIdleTimer({
    timeout,
    onIdle: handleOnIdle,
    events: [
      'keydown',
      'mousedown',
      'touchstart',
      'touchmove',
      'MSPointerDown',
    ],
  });

  return (
    isTimeoutWarningOpen &&
    sessionHelpers.isAuthenticated() && (
      <TimeoutWarning
        isVisible={isTimeoutWarningOpen}
        closeTimeoutWarning={() => setTimeoutWarningOpen(false)}
        timeoutLogout={async () => await sessionHelpers.logoutSession()}
      />
    )
  );
}

export default TimeoutCheck;
